import { createContext, useContext } from "react";

export const CockpitCtx = createContext(null);
export const useCockpit = () => useContext(CockpitCtx);
